<template>
  <div class="order-detail" v-if="form.SysNo">
    <div class="module service-info">
      <div class="b-bg"></div>
      <div class="ico">
        <img src="@/assets/express-address-ico.png" />请将商品寄至以下地址
      </div>
      <div class="info">
        <div class="name">{{form.ServiceShopName}}</div>
        <div class="name">{{form.ServiceShopLinkPhone}}</div>
        <div class="address">{{form.ServiceShopAddress}}</div>
      </div>
    </div>
    <div class="module express">
      <h5>填写快递信息</h5>
      <div class="content">
        <van-field
                v-model="submitForm.LogisticsCompany"
                name="快递公司"
                label="快递公司"
                placeholder="请填写快递公司"
        />
        <van-field
                v-model="submitForm.LogisticsNo"
                name="快递单号"
                label="快递单号"
                placeholder="请填写快递单号"
        />
      </div>
    </div>
    <div class="foot">
      <y-button class="btn" @click="submit">确认提交</y-button>
    </div>
  </div>
</template>


<script>
    import Vue from "vue";
    import { Form,Field } from 'vant';
    import { login } from "../../scripts/auth";
    import { httpOpen } from "../../scripts/network";
    Vue.use(Form)
    Vue.use(Field)
    export default {
  name: "ApplyRecord",
   data() {
    return {
        id: this.$route.params.id,
        form:{},
        submitForm:{
            OrderId:this.$route.params.id,
            LogisticsCompany:'',
            LogisticsNo:''
        }
    };
  },
  created() {
    this.loadRecord();
  },
  methods: {
      async loadRecord() {
        this.$loading.show("正在加载...");
        try {
          const ret = await httpOpen("/WuYouCard/GetServiceOrderDetail", {
            type: "post",
            body: {
              SysNo: this.id,
            },
          });
          if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
            login(this.$store, this.$router);
            return;
          } else if (!ret.Status) {
            this.$toast(ret.Message || "加载失败，请稍后重试");
          } else {
            this.form = ret.Data || {};
            this.submitForm.LogisticsCompany = this.form.InLogistics || '';
            this.submitForm.LogisticsNo = this.form.InLogisticsNo || '';
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.$loading.hide();
        }
      },
      async submit(){
          if (!this.submitForm.LogisticsCompany) {
              this.$toast("请填写快递公司");
              return;
          }
          if (!this.submitForm.LogisticsNo) {
              this.$toast("请填写快递单号");
              return;
          }
          this.$loading.show("正在加载...");
          try {
              const ret = await httpOpen("/WuYouCard/CommitLogistics", {
                  type: "post",
                  body: this.submitForm,
              });
              this.$loading.hide();
              if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
                  login(this.$store, this.$router);
                  return;
              } else if (!ret.Status) {
                  this.$toast(ret.Message || "取消失败");
              } else {
                  this.$toast({
                      message:"提交成功",
                      duration:1000,
                      onClose:()=>{
                          this.$router.back(-1)
                      }});
              }
          } catch (e) {
              this.$loading.hide();
              console.error(e);
          }
      }
  },
};
</script>

<style lang="less" scoped>
  .order-detail{
    padding: 12px;
    min-height: 100vh;
    box-sizing: border-box;
    background-color: #f3f3f3;
    .module{
      background-color: #fff;
      border-radius: 6px;
      padding: 14px 17px;
      h5{
        margin: 0;
        position: relative;
      }
      &:not(:first-child){
        margin-top: 10px;
      }

      &.service-info{
        position: relative;
        .b-bg{
          position: absolute;
          top:0;
          left: 7px;
          right: 7px;
          background: #fff url("../../assets/express-detail-ico.png") center 0 repeat-x;
          background-size: 340px 4px;
          height:8px;
        }
        .ico{
          font-size: 13px;
          color: #333333;
          border-bottom: 1px solid #f3f3f3;
          margin-top: 8px;
          padding-bottom: 9px;
          margin-bottom: 9px;
          display: flex;
          align-items: center;
          >img{
            width: 14px;
            height: 16px;
            margin-right: 10px;
          }
        }
        .info{
          font-size: 14px;
          .name{
            font-weight: 600;
            color: #000000;
            margin-bottom: 2px;
          }
          .address{
            margin-top: 6px;
            color: #333;
          }
        }
      }
      &.express{
        >h5{
          border-bottom: 1px solid #f3f3f3;
          padding-bottom: 14px;
          margin-bottom: 14px;
          color: #333;
          font-size: 13px;
        }
        .van-cell{
          padding: 10px 0;
        }
      }
    }
    .foot{
      position: fixed;
      display: flex;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #fff;
      align-items: center;
      z-index: 10;
      box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.11);
      padding: 10px 24px;
      flex-direction: column;
      p{
        font-size: 12px;
        color: #333333;
      }
    }
  }
</style>